import React, { useEffect, useState, useContext } from 'react';
import {
  QuickSummaryItem,
  SectionQuickSummaryProps,
} from './types/SectionQuickSummary.types';
import { Icon } from '@legacy-vfuk/core-icon';
import { Tooltip } from '@legacy-vfuk/core-tooltip';
import scrollToElementById from '../../../../helpers/scrollToElementById';
import {
  DateIconWrapper,
  DateTextWrapper,
  HeaderWrapper,
  SummaryItemIconWrapper,
  ReadingTimeContainer,
  ReadingTimeTextWrapper,
  ReadingTimeTooltipWrapper,
  SummaryCardWrapper,
  SummaryItemContainer,
  SummaryItemTextWrapper,
  TopSummaryLineWrapper,
  SummaryContentWrapper,
  ContentTypePillWrapper,
  SummarySpacer,
} from './styles/SectionQuickSummary.styles';
import RichTextElement from '../../Elements/RichText';
import { Heading } from '@legacy-vfuk/core-heading';
import { Pill } from '@legacy-vfuk/core-pill';
import SaveArticleIcon from '../../../SaveArticleIcon/SaveArticleIcon';

const MOBILE_VIEW_WIDTH = 638;

const handleItemClick = (item: QuickSummaryItem) => {
  scrollToElementById(item.itemTargetId);
};

const SectionQuickSummary = ({
  contentType,
  publishingDate,
  readingTime,
  readingTimeTooltipContent,
  title,
  quickSummaryItems,
  readingTimeMinuteLabel,
  displaySaveIcon,
  saveLabelText,
  saveIconClicked,
}: SectionQuickSummaryProps) => {
  const isMobile = checkWindowSize();

  const handleSaveClick = () => {
    saveIconClicked();
  };

  function checkWindowSize() {
    const [isMobile, setIsMobile] = useState(false);
    if (typeof window !== 'undefined') {
      useEffect(() => {
        function handleResize() {
          if (window.innerWidth <= MOBILE_VIEW_WIDTH) {
            setIsMobile(true);
          }
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
      }, []);
    }
    return isMobile;
  }

  return (
    <div>
      <TopSummaryLineWrapper>
        {contentType && (
          <ContentTypePillWrapper>
            <Pill
              text={contentType?.displayName}
              appearance={contentType?.isDefault ? 'primary' : 'alt1'}
            />
          </ContentTypePillWrapper>
        )}
        <DateIconWrapper>
          <Icon name="calendar-month" />
        </DateIconWrapper>
        <DateTextWrapper style={{ direction: 'ltr' }}>
          {publishingDate}
        </DateTextWrapper>
        {readingTime != null && readingTime > 0 && readingTimeMinuteLabel ? (
          readingTimeTooltipContent ? (
            <ReadingTimeTooltipWrapper>
              <Tooltip
                id="reading-time-tooltip"
                text={
                  <RichTextElement
                    key={readingTimeTooltipContent.id}
                    rawRichText={readingTimeTooltipContent.text?.raw}
                    color={readingTimeTooltipContent.color}
                    textAlign={readingTimeTooltipContent.textAlign}
                  />
                }
                size={2}
              >
                <ReadingTimeContainer>
                  <Icon name="clock" />
                  <ReadingTimeTextWrapper>
                    {readingTime} {readingTimeMinuteLabel}
                  </ReadingTimeTextWrapper>
                </ReadingTimeContainer>
              </Tooltip>
            </ReadingTimeTooltipWrapper>
          ) : (
            <ReadingTimeContainer>
              <Icon name="clock" />
              <ReadingTimeTextWrapper>
                {readingTime} {readingTimeMinuteLabel}
              </ReadingTimeTextWrapper>
            </ReadingTimeContainer>
          )
        ) : (
          <SummarySpacer />
        )}
        {displaySaveIcon && (
          <SaveArticleIcon
            saveLabel={saveLabelText}
            onArticle={true}
            handleSaveClick={handleSaveClick}
          />
        )}
      </TopSummaryLineWrapper>
      {title && quickSummaryItems && (
        <SummaryCardWrapper>
          <HeaderWrapper>
            <Heading>{title}</Heading>
          </HeaderWrapper>
          <SummaryContentWrapper>
            {quickSummaryItems &&
              quickSummaryItems.map(item => {
                return (
                  <SummaryItemContainer
                    key={item.itemTargetId}
                    onClick={() => handleItemClick(item)}
                  >
                    <SummaryItemIconWrapper>
                      <Icon name="tick-outline" appearance="secondary" />
                    </SummaryItemIconWrapper>
                    <SummaryItemTextWrapper>
                      {isMobile &&
                      item.itemTextMobile &&
                      item.itemTextMobile !== 'no_content'
                        ? item.itemTextMobile
                        : item.itemText}
                    </SummaryItemTextWrapper>
                  </SummaryItemContainer>
                );
              })}
          </SummaryContentWrapper>
        </SummaryCardWrapper>
      )}
    </div>
  );
};

export default SectionQuickSummary;
